<template>
     <div class="item-box">
       <div class="title">
        <slot name="titleY" />
        <span :class="['showMore',{'isOpen':isOpen}]" @click="showMore">{{isOpen?'展开':'收起'}}<i class="el-icon-arrow-down"></i></span>
      
       </div>
       <div class="tabbox" v-show="!isOpen">
            <slot />
       </div>
     </div>
</template>
<script>
export default {
      // props:{
      //       isOpen0:{
      //             type:Boolean,
      //             default:false
      //       }
      // },
      data(){
            return{
                  isOpen:false,
            }
      },
      watch:{
      },
      computed:{
      },
      mounted(){
            
      },
      methods:{
            // 重置数据
            reset(){
                  this.isOpen = false
            },
            showMore(){
                  this.isOpen = !this.isOpen
            },
            //数据空时
            kData(){
                  this.isOpen = true
            }
      }

}
</script>
<style scoped lang="scss">
.title{
                     font-weight: bold;
                        color: #333333;
                        height: 42px;
                        line-height: 42px;
                        background: rgba(187,190,202,0.1);
                        padding-left: 36px;
                        padding-right: 20px;
                        box-sizing: border-box;
                        position: relative;
                        margin-bottom: 16px;
                        &::before{
                              content: '';
                              position: absolute;
                              left: 24px;
                              top: 0;
                              bottom: 0;
                              margin: auto;
                              width: 4px;
                              height: 12px;
                              background: #4286F5;
                              border-radius: 1px;
                              
                        }
                        .showMore{
                              float: right;
                              font-weight: 400;
                              color: #333333;
                              font-size: 13px;
                              cursor: pointer;
                              i{
                                    margin-left: 6px;
                                    -webkit-transition: -webkit-transform .3s;
                                    transition: -webkit-transform .3s;
                                    transition: transform .3s;
                                    transition: transform .3s, -webkit-transform .3s;
                              }
                              &.isOpen .el-icon-arrow-down{
                                    transform: rotate(180deg);
                                    -ms-transform:rotate(180deg); 
                                   -webkit-transform:rotate(180deg);
                              }
                        }
               }
</style>